import type {
  ColumnFiltersState,
  RowData,
  Table,
  TableFeature,
} from "@tanstack/react-table";

export interface TableFilterInstance {
  updateColumnFilter: (columnId: string, filterValue: any) => void;
}

declare module "@tanstack/react-table" {
  interface Table<TData extends RowData> extends TableFilterInstance {}
}

export const TableFilterFeature: TableFeature<any> = {
  createTable: <TData extends RowData>(table: Table<TData>): void => {
    table.updateColumnFilter = (columnId: string, filterValue: any) => {
      table.setColumnFilters((old: ColumnFiltersState) => {
        const existingFilterIndex = old?.findIndex(
          (filter) => filter.id === columnId,
        );

        if (existingFilterIndex === -1) {
          return [...(old || []), { id: columnId, value: filterValue }];
        }

        return old?.map((filter, index) =>
          index === existingFilterIndex
            ? { ...filter, value: filterValue }
            : filter,
        );
      });
    };
  },
};
